import { render, staticRenderFns } from "./extraPage.vue?vue&type=template&id=8017942a&scoped=true"
import script from "./extraPage.vue?vue&type=script&lang=js"
export * from "./extraPage.vue?vue&type=script&lang=js"
import style0 from "./extraPage.vue?vue&type=style&index=0&id=8017942a&prod&lang=scss&scoped=true"
import style1 from "./extraPage.vue?vue&type=style&index=1&id=8017942a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8017942a",
  null
  
)

export default component.exports